import type { Parceiro } from "./tipos"

// Cooper Card (coopercard.com.br), administradora de cartões de benefício que leva o consignado aos
// clientes dela. Cores e fonte tiradas do site deles: o verde nas superfícies com texto branco, como
// os botões deles. O amarelo do logo sobre o verde dá 4,00:1 e fica de fora.
//
// O neutro dos gráficos é o azul da Faz Cred, como na Benup: verde é desfecho bom e o amarelo
// encosta no âmbar de "aperto" — as duas cores da marca viram uma fatia semântica.
//
// Sem arquivo oficial do logo ainda: o nome vai escrito na fonte e na cor da marca.
export const COOPERCARD: Parceiro = {
    slug: "coopercard",
    nome: "Cooper Card",
    doParceiro: "da Cooper Card",
    comArtigo: "a Cooper Card",
    tituloDaAba: "Cooper Card · Portal do Empregador",
    marca: { tipo: "texto", texto: "cooper card" },
    dominios: [],
    operadoPelaFazCred: true,
    tema: {
        claro: {
            brand: "#066929",
            "brand-ink": "#ffffff",
            "brand-strong": "#06522b",
            "brand-wash": "#e3f3e8",
            data: "#1e50ff",
            page: "#f7f9f7",
            card: "#ffffff",
            sunk: "#edf3ee",
            ink: "#212529",
            soft: "#3a3f44",
            faint: "#696868",
            line: "#e1e6e2",
            "line-strong": "#c4cdc6",
        },
        escuro: {
            brand: "#5cc77f",
            "brand-ink": "#0d1610",
            "brand-strong": "#86d9a1",
            "brand-wash": "#133a20",
            data: "#6b8cff",
            page: "#0b100c",
            card: "#131a15",
            sunk: "#1c251e",
            ink: "#eef5ef",
            soft: "#d6e0d8",
            faint: "#a5b2a8",
            line: "#243027",
            "line-strong": "#38463b",
        },
    },
    fontes: {
        titulo: "Ubuntu, ui-sans-serif, system-ui, sans-serif",
        texto: "Ubuntu, ui-sans-serif, system-ui, sans-serif",
        numeros: "Ubuntu, ui-sans-serif, system-ui, sans-serif",
        // A mesma Ubuntu da Metadados, nos mesmos pesos.
        carregar: () =>
            Promise.all([
                import("@fontsource/ubuntu/400.css"),
                import("@fontsource/ubuntu/500.css"),
                import("@fontsource/ubuntu/700.css"),
            ]),
    },
}
